// extracted by mini-css-extract-plugin
module.exports = {"root":"CustomTip_root__1wsn3","inputWrap":"CustomTip_inputWrap__3-6mA"};